import {
  APP_MANAGED_ROUTES,
  AuthSignIn,
  AuthSignOut,
} from '@highmark-web/highmark-common';
import { RouteObject } from '@leagueplatform/routing';
import { BrandedLandingPage } from 'pages/branded-landing.page';
import { BeneficityLanguagePage } from 'pages/static/beneficity-language.page';
import { PrivacyPage } from 'pages/static/privacy/privacy.page';

const signInPaths = [
  `${APP_MANAGED_ROUTES.SIGN_IN}/*`,
  `${APP_MANAGED_ROUTES.SIGN_IN_ALTERNATIVE}/*`,
  `${APP_MANAGED_ROUTES.START_LOGIN}/*`,
];

export const PublicRoutes: RouteObject[] = [
  ...signInPaths.map((path) => ({ path, element: <AuthSignIn /> })),
  {
    path: `${APP_MANAGED_ROUTES.SIGN_OUT}/*`,
    element: <AuthSignOut />,
  },
  {
    path: `${APP_MANAGED_ROUTES.TECHNICAL_ASSISTANCE_AND_ALL_LANGUAGES}/*`,
    element: <BeneficityLanguagePage />,
  },
  { path: '', element: <BrandedLandingPage /> },
  { path: `${APP_MANAGED_ROUTES.PRIVACY}/*`, element: <PrivacyPage /> },
];
